<template>
  <div class="cookie-consent">
    <p>{{ $t("Homepage.cookie") }}</p>
    <div class="actions">
      <button @click="$emit('accept')">{{
        $t("button.btnACCEPT")
      }}</button>
      <button @click="$emit('open-settings')">{{
        $t("button.btnSETTING")
      }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 1rem;
  text-align: center;
  z-index: 1000;
}

.actions button {
  margin: 0 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  cursor: pointer;
  background: #4caf50;
  color: white;
  border-radius: 4px;
}

.actions button:last-child {
  background: #f1c40f;
}
</style>